import { differenceInCalendarDays, format, formatDistanceToNow } from 'date-fns'

export interface FormattedDateParts {
  relative?: string
  absolute: string
}

export function formatRelativeDate(
  value?: string | Date | null,
  options?: { includeTime?: boolean; thresholdDays?: number }
): FormattedDateParts {
  if (!value) return { absolute: '—' }

  const date = typeof value === 'string' ? new Date(value) : value
  if (Number.isNaN(date?.getTime())) return { absolute: '—' }

  const threshold = options?.thresholdDays ?? 7
  const daysDiff = Math.abs(differenceInCalendarDays(new Date(), date))
  const absolute = format(date, options?.includeTime ? 'MMM d, yyyy • h:mm a' : 'MMM d, yyyy')
  const relative = daysDiff < threshold ? formatDistanceToNow(date, { addSuffix: true }) : undefined

  return { relative, absolute }
}
